/**
 * Lightweight scope helpers. The backend is the source of truth for permission
 * gating; the frontend uses these for menu visibility and conditional render.
 *
 * `superuser` bypasses everything. `internal` users see the platform routes;
 * `external` users see only their own merchant's data.
 *
 * (Permission-key based gating is server-side — most UI checks here are scope-based.)
 */
import type { Profile } from '../api/types';

export function isSuperuser(p: Profile): boolean {
  return p.isSuperuser;
}
export function isPlatform(p: Profile): boolean {
  return p.userType === 'internal' || p.isSuperuser;
}
export function isMerchantUser(p: Profile): boolean {
  return p.userType === 'external' && !p.isSuperuser;
}
